<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogcreate = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tabledata" stripe highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('Childcare_Application_Salary_Changede.Selectemployee')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.childcareapplication.emp.name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Childcare_Application_Salary_Changede.holidaystarttime')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.childcareapplication.leave_start_time | formatDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Childcare_Application_Salary_Changede.scheduledendtime')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.childcareapplication.leave_end_time | formatDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Childcare_Application_Salary_Changede.averageamount')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.average_amount}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Childcare_Application_Salary_Changede.operating')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleedit(scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handledelete(scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.row)">
            {{$t('general.print')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--add-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogcreate" width="80%" :before-close="handleclose">
      <el-form :model="formcreate" :rules="rules" ref="formcreate" :label-position="labelPosition" label-width="180px" class="demo-ruleForm" size="medium">

        <el-collapse accordion>
          <el-collapse-item :title="$t('Childcare_Application_Salary_Changede.Basicinformation')" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.Selectemployee')" style="margin-left:50px">
                    <el-select v-model="formcreate.emp_id" refix-icon="el-icon-edit" style="margin-right:90px;width:185px" size="mini" @change="idSelected" placeholder>
                      <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.logicnumber')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="formcreate.seiribangou" readonly="readonly" size="mini" style="margin-right:90px;width:185px" placeholder></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.holidaystarttime')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.leave_start_time" readonly="readonly" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px" type="date"></el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.scheduledendtime')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.leave_end_time" readonly="readonly" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px" type="date"></el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.actualenddate')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.leave_end_time2" readonly="readonly" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px" type="date" placeholder>
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('Childcare_Application_Salary_Changede.childinformation')" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.familyname')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="formcreate.sun_f_name" readonly="readonly" size="mini" style="margin-right:90px;width:185px" placeholder></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.category')" prop style="margin-left:50px">
                    <el-select v-model="formcreate.sun_code" style="margin-right:90px;width:185px" readonly="readonly" size="mini" placeholder>
                      <el-option v-for="item in sun_code" :key="item.id" :label="item.label" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.childbirthday')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.sun_birthday" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px" readonly="readonly" type="date"></el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.thedateofparenting')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.childcare_start_time" readonly="readonly" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px" type="date" placeholder>
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.givenname')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="formcreate.sun_g_name" readonly="readonly" size="mini" style="margin-right:90px;width:185px" placeholder></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Applicationde.pplicabletomaternityleave')" style="margin-left:50px">
                    <el-select v-model="formcreate.papamama_check" style="margin-right:90px;width:185px" readonly="readonly" size="mini" placeholder>
                      <el-option v-for="item in papamama_code" :key="item.id" :label="item.label" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.note')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" readonly="readonly" v-model="formcreate.note" size="mini" style="margin-right:90px;width:185px" placeholder></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('Childcare_Application_Salary_Changede.salarychange')" style="margin-left:10px">
            <el-row>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancemonth')" label-width="70px" style="margin-left:50px; margin-right: 10px;">
                  <el-select v-model="formcreate.salary_month1" style="margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancedays')" label-width="70px" style="margin-left:20px;">
                  <el-select v-model="formcreate.salary_days1" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.currency')" label-width="70px">
                  <el-input v-model.number="formcreate.currency1" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.spot')" label-width="70px">
                  <el-input v-model.number="formcreate.spot1" @blur="add1" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.total')" label-width="70px">
                  <el-input v-model="formcreate.totle1" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.grandtotal')" label-width="82px">
                  <el-input v-model="formcreate.grand_total" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <hr />

            <el-row>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancemonth')" label-width="70px" style="margin-left:50px; margin-right: 10px;">
                  <el-select v-model="formcreate.salary_month2" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancedays')" label-width="70px" style="margin-left:20px;">
                  <el-select v-model="formcreate.salary_days2" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.currency')" label-width="70px">
                  <el-input v-model.number="formcreate.currency2" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.spot')" label-width="70px">
                  <el-input v-model.number="formcreate.spot2" @blur="add2" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.total')" label-width="70px">
                  <el-input v-model="formcreate.totle2" readonly="readonly" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.averageamount')" label-width="82px">
                  <el-input v-model="formcreate.average_amount" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <hr />

            <el-row>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancemonth')" label-width="70px" style="margin-left:50px; margin-right: 10px;">
                  <el-select v-model="formcreate.salary_month3" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancedays')" label-width="70px" style="margin-left:20px;">
                  <el-select v-model="formcreate.salary_days3" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.currency')" label-width="70px">
                  <el-input v-model.number="formcreate.currency3" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.spot')" label-width="70px">
                  <el-input v-model.number="formcreate.spot3" @blur="add3" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.total')" label-width="70px">
                  <el-input v-model="formcreate.totle3" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.revisedaverage')" label-width="82px">
                  <el-input v-model="formcreate.modified_average_amount" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <hr />

            <el-form-item>
              <el-button type="primary" @click="account()">{{$t('pensionbasicde.payoff')}}</el-button>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('formcreate')" type="primary" size="medium">{{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('formcreate')" size="medium">{{$t('general.cancel')}}
        </el-button>
        <el-button style="width:120px" @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
      </span>
    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogupdate" width="80%" :before-close="handleclose">
      <el-form :model="formcreate" :rules="rules" ref="formcreate" :label-position="labelPosition" label-width="180px" class="demo-ruleForm" size="mini">

        <el-collapse accordion>
          <el-collapse-item :title="$t('Childcare_Application_Salary_Changede.Basicinformation')" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.logicnumber')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="formcreate.seiribangou" size="mini" readonly="readonly" style="margin-right:90px;width:185px" placeholder></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.holidaystarttime')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.leave_start_time" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px" type="date"></el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.scheduledendtime')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.leave_end_time" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px" type="date"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('Childcare_Application_Salary_Changede.childinformation')" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.familyname')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="formcreate.sun_f_name" size="mini" style="margin-right:90px;width:185px" placeholder></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.category')" prop style="margin-left:50px">
                    <el-select v-model="formcreate.sun_code" style="margin-left:10px;width: 185px" size="mini" placeholder>
                      <el-option v-for="item in sun_code" :key="item.id" :label="item.label" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.childbirthday')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.sun_birthday" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px;margin-left:10px" type="date"></el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.thedateofparenting')" style="margin-left:50px">
                    <el-date-picker v-model="formcreate.childcare_start_time" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:185px;margin-left:10px" type="date" placeholder></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.givenname')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="formcreate.sun_g_name" size="mini" style="margin-right:90px;width:185px;margin-left:10px" placeholder></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Applicationde.pplicabletomaternityleave')" style="margin-left:50px">
                    <el-select v-model="formcreate.papamama_check" style="margin-left:10px;width: 185px" size="mini" placeholder>
                      <el-option v-for="item in papamama_code" :key="item.id" :label="item.label" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('Childcare_Application_Salary_Changede.note')" prop="name" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="formcreate.note" size="mini" style="margin-right:90px;width:185px;margin-left:10px" placeholder></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('Childcare_Application_Salary_Changede.salarychange')" style="margin-left:10px">
            <el-row>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancemonth')" label-width="70px" style="margin-left:50px; margin-right: 10px;">
                  <el-select v-model="formcreate.salary_month1" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancedays')" label-width="70px" style="margin-left:20px;">
                  <el-select v-model="formcreate.salary_days1" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.currency')" label-width="70px">
                  <el-input v-model.number="formcreate.currency1" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.spot')" label-width="70px">
                  <el-input v-model.number="formcreate.spot1" style="margin-left:5px; margin-right:10px;width:100px" size="mini" @blur="add1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.total')" label-width="70px">
                  <el-input v-model="formcreate.totle1" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.grandtotal')" label-width="82px">
                  <el-input v-model="formcreate.grand_total" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <hr />

            <el-row>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancemonth')" label-width="70px" style="margin-left:50px; margin-right: 10px;">
                  <el-select v-model="formcreate.salary_month2" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancedays')" label-width="70px" style="margin-left:20px;">
                  <el-select v-model="formcreate.salary_days2" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.currency')" label-width="70px">
                  <el-input v-model.number="formcreate.currency2" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.spot')" label-width="70px">
                  <el-input v-model.number="formcreate.spot2" style="margin-left:5px; margin-right:10px;width:100px" size="mini" @blur="add2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.total')" label-width="70px">
                  <el-input v-model="formcreate.totle2" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.averageamount')" label-width="82px">
                  <el-input v-model="formcreate.average_amount" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <hr />

            <el-row>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancemonth')" label-width="70px" style="margin-left:50px; margin-right: 10px;">
                  <el-select v-model="formcreate.salary_month3" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.attendancedays')" label-width="70px" style="margin-left:20px;">
                  <el-select v-model="formcreate.salary_days3" style="margin-left:5px; margin-right:10px;width:100px" size="mini" placeholder>
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.currency')" label-width="70px">
                  <el-input v-model.number="formcreate.currency3" style="margin-left:5px; margin-right:10px;width:100px" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.spot')" label-width="70px">
                  <el-input v-model.number="formcreate.spot3" style="margin-left:5px; margin-right:10px;width:100px" size="mini" @blur="add3"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.total')" label-width="70px">
                  <el-input v-model="formcreate.totle3" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('Childcare_Application_Salary_Changede.revisedaverage')" label-width="82px">
                  <el-input v-model="formcreate.modified_average_amount" style="margin-left:5px; margin-right:10px;width:100px" size="mini" readonly="readonly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="update('formcreate')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('formcreate')" size="medium">{{$t('general.cancel')}}
        </el-button>
      </span>
    </el-dialog>

    <!-- <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div> -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      labelPosition: "left",
      dialogcreate: false,
      dialogupdate: false,
      pageSize: 6,
      currentPage: 1,
      total: 0,
      formcreate: {
        seiribangou: "",
        emp_id: "",
        sun_f_name: "",
        sun_g_name: "",
        sun_birthday: "",
        sun_code: "",
        childcare_start_time: "",
        leave_start_time: "",
        leave_end_time: "",
        papamama_check: "",
        note: "",
        leave_end_time2: "",
        salary_month1: "",
        salary_month2: "",
        salary_month3: "",
        salary_days1: "",
        salary_days2: "",
        salary_days3: "",
        currency1: "",
        currency2: "",
        currency3: "",
        spot1: "",
        spot2: "",
        spot3: "",
        totle1: "",
        totle2: "",
        totle3: "",
        grand_total: "",
        average_amount: "",
        modified_average_amount: "",
      },
      emp: [],
      tabledata: [],
      sun_code: [{
        id: 1,
        label: "実子",
      },
      {
        id: 2,
        label: "その他",
      },
      ],
      days: [{
        codeid: 1,
        label: "1",
      },
      {
        codeid: 2,
        label: "2",
      },
      {
        codeid: 3,
        label: "3",
      },
      {
        codeid: 4,
        label: "4",
      },
      {
        codeid: 5,
        label: "5",
      },
      {
        codeid: 6,
        label: "6",
      },
      {
        codeid: 7,
        label: "7",
      },
      {
        codeid: 8,
        label: "8",
      },
      {
        codeid: 9,
        label: "9",
      },
      {
        codeid: 10,
        label: "10",
      },
      {
        codeid: 11,
        label: "11",
      },
      {
        codeid: 12,
        label: "12",
      },
      {
        codeid: 13,
        label: "13",
      },
      {
        codeid: 14,
        label: "14",
      },
      {
        codeid: 15,
        label: "15",
      },
      {
        codeid: 16,
        label: "16",
      },
      {
        codeid: 17,
        label: "17",
      },
      {
        codeid: 18,
        label: "18",
      },
      {
        codeid: 19,
        label: "19",
      },
      {
        codeid: 20,
        label: "20",
      },
      {
        codeid: 21,
        label: "21",
      },
      {
        codeid: 22,
        label: "22",
      },
      {
        codeid: 23,
        label: "23",
      },
      {
        codeid: 24,
        label: "24",
      },
      {
        codeid: 25,
        label: "25",
      },
      {
        codeid: 26,
        label: "26",
      },
      {
        codeid: 27,
        label: "27",
      },
      {
        codeid: 28,
        label: "28",
      },
      {
        codeid: 29,
        label: "29",
      },
      {
        codeid: 30,
        label: "30",
      },
      {
        codeid: 31,
        label: "31",
      },
      ],
      month: [{
        codeid: 1,
        label: "1",
      },
      {
        codeid: 2,
        label: "2",
      },
      {
        codeid: 3,
        label: "3",
      },
      {
        codeid: 4,
        label: "4",
      },
      {
        codeid: 5,
        label: "5",
      },
      {
        codeid: 6,
        label: "6",
      },
      {
        codeid: 7,
        label: "7",
      },
      {
        codeid: 8,
        label: "8",
      },
      {
        codeid: 9,
        label: "9",
      },
      {
        codeid: 10,
        label: "10",
      },
      {
        codeid: 11,
        label: "11",
      },
      {
        codeid: 12,
        label: "12",
      },
      ],
      papamama_code: [{
        id: 1,
        label: "パパママ育休該当",
      },
      {
        id: 2,
        label: "その他",
      },
      ],
    };
  },
  methods: {
    preview(index, row) {
      this.axios.post("/currentUserId").then((response) => {
        console.log(response.data);
        var uid = response.data;
        window.open(
          "/pdf/健康保険厚生年金保険被保険者育児休業等終了時報酬月額変更届-" +
          "uid=" +
          uid +
          ".pdf"
        );
      });
    },
    handleclose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    handleedit(row) {
      this.formcreate.id_pk = row.childcareapplication.id_pk;
      this.formcreate.com_id = row.childcareapplication.com_id;
      this.formcreate.seiribangou = row.childcareapplication.seiribangou;
      this.formcreate.emp_id = row.childcareapplication.emp_id;
      this.formcreate.sun_f_name = row.childcareapplication.sun_f_name;
      this.formcreate.sun_g_name = row.childcareapplication.sun_g_name;
      this.formcreate.sun_birthday = row.childcareapplication.sun_birthday;
      this.formcreate.sun_code = row.childcareapplication.sun_code;
      this.formcreate.childcare_start_time =
        row.childcareapplication.childcare_start_time;
      this.formcreate.leave_start_time =
        row.childcareapplication.leave_start_time;
      this.formcreate.leave_end_time = row.childcareapplication.leave_end_time;
      this.formcreate.papamama_check = row.childcareapplication.papamama_check;
      this.formcreate.note = row.childcareapplication.note;
      this.formcreate.leave_end_time2 =
        row.childcareapplication.leave_end_time2;
      (this.formcreate.salary_month1 = row.salary_month1),
        (this.formcreate.salary_month2 = row.salary_month2),
        (this.formcreate.salary_month3 = row.salary_month3),
        (this.formcreate.salary_days1 = row.salary_days1),
        (this.formcreate.salary_days2 = row.salary_days2),
        (this.formcreate.salary_days3 = row.salary_days3),
        (this.formcreate.currency1 = row.currency1),
        (this.formcreate.currency2 = row.currency2),
        (this.formcreate.currency3 = row.currency3),
        (this.formcreate.spot1 = row.spot1),
        (this.formcreate.spot2 = row.spot2),
        (this.formcreate.spot3 = row.spot3),
        (this.formcreate.totle1 = row.totle1),
        (this.formcreate.totle2 = row.totle2),
        (this.formcreate.totle3 = row.totle3),
        (this.formcreate.grand_total = row.grand_total),
        (this.formcreate.average_amount = row.average_amount),
        (this.formcreate.modified_average_amount = row.modified_average_amount),
        (this.dialogupdate = true);
      console.log(this.formcreate);
      console.log("formcreate" + this.formcreate);
      console.log(row);
    },

    printPDF(row) {
      let postData = this.qs.stringify({
        emp_id: row.childcareapplication.emp_id,
      });
      this.axios({
        method: "post",
        url: "/printchildcareapplicationsalarychange",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handledelete(row) {
      this.$confirm(this.$t("general.sure_delete"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            emp_id: row.emp_id,
          });
          this.axios({
            method: "post",
            url: "/deletechildcareapplication",
            data: postData,
          })
            .then((response) => {
              this.refreshdata();
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },

    refreshdata() {
      this.axios
        .post("/listchildcareapplicationsalarychange")
        .then((response) => {
          this.tabledata = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      d;
    },
    emptydate() {
      this.formcreate.id_pk = "";
      this.formcreate.com_id = "";
      this.formcreate.seiribangou = "";
      this.formcreate.emp_id = "";
      this.formcreate.sun_f_name = "";
      this.formcreate.sun_g_name = "";
      this.formcreate.sun_birthday = "";
      this.formcreate.sun_code = "";
      this.formcreate.childcare_start_time = "";
      this.formcreate.leave_start_time = "";
      this.formcreate.leave_end_time = "";
      this.formcreate.papamama_check = "";
      this.formcreate.note = "";
      this.formcreate.leave_end_time2 = "";
    },

    s1_cancel(formcreate) {
      this.dialogcreate = false;
      this.dialogupdate = false;
      this.emptydate();
      this.$refs[formcreate].resetFields();
    },
    cancel() {
      this.dialogcreate = false;
      this.dialogupdate = false;
      this.emptydate();
    },

    add(formcreate) {
      this.$refs[formcreate].validate((valid) => {
        if (valid) {
          let adddata = this.qs.stringify(this.formcreate);
          this.axios({
            method: "post",
            url: "/insertchildcareapplicationsalarychange",
            data: adddata,
          })
            .then((response) => {
              this.$message({
                type: "success",
                message: this.$t("general.add_completed"),
              });
              this.dialogcreate = false;
              this.refreshdata();
              this.emptydate();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },
    idSelected() {
      let data = this.qs.stringify({
        emp_id: this.formcreate.emp_id,
      });
      this.axios({
        method: "post",
        url: "/listchildcareapplicationbyid",
        data: data,
      })
        .then((response) => {
          this.formcreate.id_pk = response.data.id_pk;
          this.formcreate.com_id = response.data.com_id;
          this.formcreate.seiribangou = response.data.seiribangou;
          //this.formcreate.emp_id = response.emp_id;
          this.formcreate.sun_f_name = response.data.sun_f_name;
          this.formcreate.sun_g_name = response.data.sun_g_name;
          this.formcreate.sun_birthday = response.data.sun_birthday;
          this.formcreate.sun_code = response.data.sun_code;
          this.formcreate.childcare_start_time =
            response.data.childcare_start_time;
          this.formcreate.leave_start_time = response.data.leave_start_time;
          this.formcreate.leave_end_time = response.data.leave_end_time;
          this.formcreate.papamama_check = response.data.papamama_check;
          this.formcreate.note = response.data.note;
          this.formcreate.leave_end_time2 = response.data.leave_end_time2;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    account() {
      let data = this.qs.stringify({
        salary_month1: this.formcreate.salary_month1,
        salary_month2: this.formcreate.salary_month2,
        salary_month3: this.formcreate.salary_month3,
        salary_days1: this.formcreate.salary_days1,
        salary_days2: this.formcreate.salary_days2,
        salary_days3: this.formcreate.salary_days3,
        currency1: this.formcreate.currency1,
        currency2: this.formcreate.currency2,
        currency3: this.formcreate.currency3,
        spot1: this.formcreate.spot1,
        spot2: this.formcreate.spot2,
        spot3: this.formcreate.spot3,
        totle1: this.formcreate.totle1,
        totle2: this.formcreate.totle2,
        totle3: this.formcreate.totle3,
        grand_total: this.formcreate.grand_total,
        average_amount: this.formcreate.average_amount,
        modified_average_amount: this.formcreate.modified_average_amount,
      });
      this.axios({
        method: "post",
        url: "/acountchildcareapplicationsalarychange",
        data: data,
      })
        .then((response) => {
          this.formcreate.totle1 = response.data.totle1;
          this.formcreate.totle2 = response.data.totle2;
          this.formcreate.totle3 = response.data.totle3;
          this.formcreate.grand_total = response.data.grand_total;
          this.formcreate.average_amount = response.data.average_amount;
          this.formcreate.modified_average_amount =
            response.data.modified_average_amount;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    update(formcreate) {
      this.$refs[formcreate].validate((valid) => {
        if (valid) {
          let adddata = this.qs.stringify(this.formcreate);
          this.axios({
            method: "post",
            url: "/updatechildcareapplication",
            data: adddata,
          })
            .then((response) => {
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              this.dialogupdate = false;
              this.refreshdata();
              this.emptydate();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    add1() {
      this.formcreate.totle1 =
        parseInt(this.formcreate.currency1) + parseInt(this.formcreate.spot1);
    },

    add2() {
      this.formcreate.totle2 =
        parseInt(this.formcreate.currency2) + parseInt(this.formcreate.spot2);
    },

    add3() {
      this.formcreate.totle3 =
        parseInt(this.formcreate.currency3) + parseInt(this.formcreate.spot3);
    },

    clearall() {
      this.formcreate.salary_month1 = "";
      this.formcreate.salary_month2 = "";
      this.formcreate.salary_month3 = "";
      this.formcreate.salary_days1 = "";
      this.formcreate.salary_days2 = "";
      this.formcreate.salary_days3 = "";
      this.formcreate.currency1 = "";
      this.formcreate.currency2 = "";
      this.formcreate.currency3 = "";
      this.formcreate.spot1 = "";
      this.formcreate.spot2 = "";
      this.formcreate.spot3 = "";
      this.formcreate.totle1 = "";
      this.formcreate.totle2 = "";
      this.formcreate.totle3 = "";
      this.formcreate.grand_total = "";
      this.formcreate.average_amount = "";
      this.formcreate.modified_average_amount = "";
    },
  },
  created() {
    this.axios
      .post("/listchildcareapplicationsalarychange")
      .then((response) => {
        this.tabledata = response.data;
      })
      .catch((error) => {
        this.show = false;
        this.$message({ type: 'error', message: '開発中です。' });
        console.log(error);
      });
    this.axios
      .post("/listname")
      .then((response) => {
        this.emp = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>


<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.style1 {
  margin-right: 145px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/Childcare_Application_Salary_Change.vue